import * as React from 'react';
export const monduSvg = React.forwardRef(function monduSvgInner(props, ref) {
  return /*#__PURE__*/ React.createElement(
    'svg',
    {
      ...props,
      ref: ref,
    },
    /*#__PURE__*/ React.createElement('path', {
      fill: '#8B4AFF',
      d: 'M0 0h32v32H0z',
    }),
    /*#__PURE__*/ React.createElement('path', {
      d: 'M15.98 5c-6 0-10.43 4.64-10.43 10.98C5.55 22.359 9.98 27 15.98 27c6.042 0 10.47-4.638 10.47-11.021C26.45 9.639 22.022 5 15.98 5Zm5.184 13.048a2.4 2.4 0 0 1-.46 1.37 2.29 2.29 0 0 1-1.151.833L11.1 23.095a.194.194 0 0 1-.18-.029.205.205 0 0 1-.082-.166v-8.954a2.39 2.39 0 0 1 .458-1.37c.29-.395.693-.687 1.152-.833l8.454-2.841a.195.195 0 0 1 .18.029.204.204 0 0 1 .082.166v8.951Z',
      fill: '#fff',
    }),
  );
});
monduSvg.defaultProps = {
  width: '32',
  height: '32',
  viewBox: '0 0 32 32',
  fill: 'none',
  xmlns: 'http://www.w3.org/2000/svg',
};
export var mondu = {
  category: 'brand',
  colorable: false,
  name: 'mondu',
  svg: monduSvg,
};
